import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6144c4a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section others" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title sub-title" }, "その他", -1))
const _hoisted_3 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmInput = _resolveComponent("ConfirmInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("table", _hoisted_3, [
      _createElementVNode("tbody", null, [
        _createVNode(_component_ConfirmInput, {
          name: 'その他',
          value: _ctx.state,
          class: _normalizeClass('others')
        }, null, 8, ["value"])
      ])
    ])
  ]))
}